module.exports = __webpack_public_path__ + "img/Pink.f1e93438.png";